import { IColunaGridColor } from './IColunaGridColor';
import { ComponentFactoryResolver, ComponentFactory } from '@angular/core';
import { IComponenteColunaGrid } from '../IComponenteColunaGrid';
import { ColunaGridComponent } from './coluna-grid/coluna-grid.component';

export class ColunaGridColor
    implements IColunaGridColor {

    private width: string;
    private icon: any;
    private action: any;
    private color: string;

    public constructor(
        private field: string,
        private headerText: string,
    ) {
        this.action = null;
    }

    setWidth(width: string) {
        this.width = width;
    }

    getWidth(): string {
        return this.width;
    }

    getIcon(): any {
        return this.icon;
    }

    getFieldName(): string {
        return this.field;
    }

    getTitleAction() {
        this.action();
    }

    isAction(): boolean {
        return this.action
    }

    getHeaderText(): string {
        return this.headerText;
    }

    getColor() {
        return this.color;
    }
    
    setColor(color: string) {
        this.color = color;
    }

    getColorAtributes(): {} {
        return {'scope': 'col', 'style': 'color: ' + this.getColor() + ';'};
    }

    getHeaderAtributes(): {} {
        return {'scope': 'col', 'style': 'width: ' + this.getWidth() + '; text-align: center;'};
    }
    
    getCellAtributes(): {} {
        return {};
    }

    getCellData(pComponentFactoryResolver: ComponentFactoryResolver): ComponentFactory<IComponenteColunaGrid> {
        return pComponentFactoryResolver.resolveComponentFactory(ColunaGridComponent);
    }
}
